import React from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const FinalCTA = () => {
  const location = useLocation();
  const isServicesPage = location.pathname === '/services';

  const headline = isServicesPage
    ? "Let's Find the Right Help for Your Organization"
    : 'Stop Chasing Technology Problems on Your Own';

  const subtext = isServicesPage
    ? 'Start with one project or talk with us about an ongoing plan for your website, email, hosting, security, and technical operations.'
    : 'Tell us what is happening with your website, business email, hosting, security, or technical setup, and we will help work out the next step.';

  return (
    <section className="border-t border-[#D7B77A]/40 bg-[#174C3C] py-24 text-white">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <div className="mx-auto mb-8 h-px w-16 bg-[#D7B77A]" />
        <h2 className="text-4xl leading-tight sm:text-5xl lg:text-6xl">
          {headline}
        </h2>
        <p className="mx-auto mt-8 max-w-3xl text-xl leading-relaxed text-white/75">
          {subtext}
        </p>
        <div className="mt-10">
          <Link
            to="/digital-review"
            className="home-button-on-dark"
          >
            Request a Digital Review
          </Link>
        </div>
        <p className="mt-10 text-base text-white/60">
          Need white-label support?{' '}
          <Link
            to="/agency-services"
            className="font-bold text-[#D7B77A] underline underline-offset-4"
          >
            See agency services.
          </Link>
        </p>
      </div>
    </section>
  );
};

export default FinalCTA;